// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\EmailSentSearchResponse

import { hydrateEmailSent, type EmailSent, type EmailSentApiResponse } from './emailSent.gen';

export type EmailSentSearchApiResponse = {
	items: EmailSentApiResponse[];
};

export type EmailSentSearch = {
	items: EmailSent[];
};

export function hydrateEmailSentSearch(data: EmailSentSearchApiResponse): EmailSentSearch {
	return {
		...data,
		items: data.items.map(hydrateEmailSent),
	};
}